// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"feed8e34","667":"9c9549bd"}[chunkId] + ".chunk.js";
};